export default function isClinicalTrialSite(siteValue: string) {
  try {
    const siteArray = (process.env.NEXT_PUBLIC_CLINICAL_TRIALS_SITE || 'ClinicalResearch')?.split(
      '|'
    );
    if (siteArray?.includes(siteValue)) {
      return true;
    }
  } catch (error) {
    return false;
  }
  return false;
}

/** Mega screener tenant key from merged site settings (partial settings override). Omit when empty. */
export function getMegaScreenerTenantKey(siteSettings: any): string | undefined {
  const value = siteSettings?.megaScreenerTenantKey?.value;
  if (value == null || value === '') {
    return undefined;
  }
  return String(value);
}

export function isMegaScreenerStudy(siteSettings: any): boolean {
  const megaScreenerTenantKey = siteSettings?.megaScreenerTenantKey?.value;
  if (megaScreenerTenantKey == null || megaScreenerTenantKey === '') {
    return false;
  }
  return true;
}

export type ScreenerOutcomeParam = {
  key: string;
  value: string;
  isPII?: boolean;
};

const MEGA_SCREENER_STUDY_NAME_KEY = 'lastScreenedTA';
const MEGA_SCREENER_CONDITION_NAME_KEY = 'lastScreenedCondition';

export function getScreenerOutcomeParamValue(
  params: ScreenerOutcomeParam[] | null | undefined,
  key: string
): string | undefined {
  return params?.find((param) => param.key === key)?.value;
}

function getMegaScreenerOutcomeParamValue(
  megaScreenerParams: ScreenerOutcomeParam[] | null | undefined,
  cdpParams: ScreenerOutcomeParam[] | null | undefined,
  key: string
): string | undefined {
  const megaScreenerValue = getScreenerOutcomeParamValue(megaScreenerParams, key);
  if (megaScreenerValue != null && megaScreenerValue !== '') {
    return megaScreenerValue;
  }
  return getScreenerOutcomeParamValue(cdpParams, key);
}

export function getPrimaryStudyAndConditionNames(
  siteSettings: any,
  cdpData?: { screenerOutcomeParams?: ScreenerOutcomeParam[] | null },
  megaScreenerOutcomeParameter?: ScreenerOutcomeParam[] | null
): { primaryStudyName?: string; primaryConditionName?: string } {
  if (isMegaScreenerStudy(siteSettings)) {
    const cdpScreenerOutcomeParams = cdpData?.screenerOutcomeParams;
    return {
      primaryStudyName: getMegaScreenerOutcomeParamValue(
        megaScreenerOutcomeParameter,
        cdpScreenerOutcomeParams,
        MEGA_SCREENER_STUDY_NAME_KEY
      ),
      primaryConditionName: getMegaScreenerOutcomeParamValue(
        megaScreenerOutcomeParameter,
        cdpScreenerOutcomeParams,
        MEGA_SCREENER_CONDITION_NAME_KEY
      ),
    };
  }

  return {
    primaryStudyName: siteSettings?.studyName?.value,
    primaryConditionName: siteSettings?.projectTherapeuticArea?.fields?.description?.value,
  };
}

export function isDifferentBrowserResumeJourneyEnabled(siteSettings: any): boolean {
  const isMegaScreener = isMegaScreenerStudy(siteSettings);
  if (
    (!siteSettings?.disableResumeJourney?.value && !isMegaScreener) ||
    (siteSettings?.isResumeDifferentBrowser?.value && isMegaScreener)
  ) {
    return true;
  }
  return false;
}
